module.exports = __webpack_public_path__ + "static/media/prabhupada.15d8ea9c.webp";